module.exports = __webpack_public_path__ + "static/media/bfile-403b.3a09654d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-403b.svg
// module id = 255
// module chunks = 0